(function () {
  'use strict';

  function formatFeeLabel(amount) {
    var fee = parseInt(amount, 10);
    if (isNaN(fee) || fee <= 0) return 'FREE for you!';
    return '₹' + fee + ' for you!';
  }

  function formatBadgeLabel(amount) {
    var fee = parseInt(amount, 10);
    if (isNaN(fee) || fee <= 0) return 'Free';
    return '₹' + fee;
  }

  function updateNoteElement(note) {
    if (!note) return Promise.resolve();

    var enabled = note.getAttribute('data-fee-enabled') !== 'false';
    var feeAmount = parseInt(note.getAttribute('data-fee-amount'), 10) || 0;
    var freeRules = note.getAttribute('data-free-rules-enabled') === 'true';
    var freeAbove = parseInt(note.getAttribute('data-free-above'), 10) || 0;
    var displayMode = note.getAttribute('data-fee-display') || 'note';
    var label = note.querySelector('[data-personalization-fee-label]');
    var compareEl = note.querySelector('[data-personalization-fee-compare]');

    if (!label) return Promise.resolve();

    function applyLabel(text) {
      label.textContent = text;
    }

    if (compareEl) {
      var compareAmount = parseInt(note.getAttribute('data-compare-amount'), 10) || 0;
      compareEl.textContent = compareAmount > 0 ? '₹' + compareAmount : '';
    }

    if (!enabled || feeAmount <= 0) {
      applyLabel(displayMode === 'badge' ? 'Free' : 'FREE for you!');
      return Promise.resolve();
    }

    if (!freeRules || freeAbove <= 0) {
      applyLabel(displayMode === 'badge' ? formatBadgeLabel(feeAmount) : formatFeeLabel(feeAmount));
      return Promise.resolve();
    }

    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      })
      .then(function (cart) {
        var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
        var isFree = total >= freeAbove;

        if (displayMode === 'badge') {
          applyLabel(isFree ? 'Free' : formatBadgeLabel(feeAmount));
        } else {
          applyLabel(isFree ? 'FREE for you!' : formatFeeLabel(feeAmount));
        }
      })
      .catch(function () {
        applyLabel(displayMode === 'badge' ? formatBadgeLabel(feeAmount) : formatFeeLabel(feeAmount));
      });
  }

  function updateAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var notes = scope.querySelectorAll('[data-personalization-fee-note]');

    if (!notes.length) return Promise.resolve();

    return Promise.all(Array.prototype.map.call(notes, updateNoteElement));
  }

  window.RabitatPersonalizationFee = {
    updateAll: updateAll,
    updateNote: updateNoteElement
  };
})();
